import { useAgentRosterQuery } from 'hooks/useAgents';

export function AgentsOnlineRail() {
  const { data: roster = [] } = useAgentRosterQuery();
  const available = roster.filter(
    (a) => a.derivedStatus === 'online' || a.derivedStatus === 'full',
  );

  if (available.length === 0) {
    return <div className="text-xs text-gray-400">Inga agenter online just nu.</div>;
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs text-gray-400">Lediga just nu:</span>
      {available.map((agent) => {
        const free = Math.max(0, agent.load.max - agent.load.active);
        const full = free <= 0;
        return (
          <span
            key={agent.userId}
            className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs ${
              full ? 'bg-amber-50 text-amber-700' : 'bg-green-50 text-green-700'
            }`}
          >
            <span
              className={`h-1.5 w-1.5 rounded-full ${full ? 'bg-amber-500' : 'bg-green-500'}`}
            />
            {agent.alias} · {full ? 'fullt' : `${free} ${free === 1 ? 'ledig' : 'lediga'}`}
          </span>
        );
      })}
    </div>
  );
}
